module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-15.5978c2fe.png";